import React from 'react'
import NavBar from '../Component/NavBarFooter/NavBar'
import Footer from '../Component/NavBarFooter/Footer'
import Content from '../Component/ScholarshipDetail/Content'
import { useParams } from 'react-router-dom'
import { useAuth } from '../Context/ContextProvider'
import { useState } from 'react'
import { useEffect } from 'react'

function ScollershipDetail() {
    const {id}=useParams()
    const {getScholarshipDetails}=useAuth()
    const [scholarshipDetail, setScholarshipDetail] = useState(null)
    useEffect(()=>{
        const fetchScholarshipDetail=async()=>{
            const resp=await getScholarshipDetails(id)
            if(resp.success){
                setScholarshipDetail(resp.data?.scholarship)
            }
        }
        fetchScholarshipDetail()
    },[id])
  return (
    <div>
        <NavBar/>
        <Content jobDetail={scholarshipDetail}/>
        <Footer/>
    </div>
  )
}

export default ScollershipDetail